// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"input_inputBox__1yD5o"};